import classnames from 'classnames';
import React from 'react';

import { yAxisTicks } from './config';

interface BarChartYAxisLabelsProps {
  locale: string;
  isHidden: boolean;
  ticks?: number[];
  isPercentage?: boolean;
}

export const BarChartYAxisLabels: React.FC<BarChartYAxisLabelsProps> = ({
  isHidden,
  locale,
  ticks = yAxisTicks,
  isPercentage = true,
}) => (
  <div
    className={classnames('adherence-history__bar-chart__y-axis-container', {
      'adherence-history__bar-chart__y-axis-container--hidden': isHidden,
    })}
    data-test-id="adherence-history-detail:bar-chart-y-axis"
  >
    {ticks.map((tick) =>
      isPercentage ? (
        <span key={tick}>{(tick / 100).toLocaleString(locale, { maximumFractionDigits: 2, style: 'percent' })}</span>
      ) : (
        <span key={tick}>{tick.toLocaleString(locale)}</span>
      )
    )}
  </div>
);
